module.exports = __webpack_public_path__ + "img/giphy.5e370002.webp";